// extracted by mini-css-extract-plugin
export default {"input":"TableCheckbox_input__ppmmW"};